import React, { Component } from 'react';
import { Input, Row, Col, Form, Button, FormGroup, FormFeedback, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Logo from '../../logo';
import Preloader from '../../UI/Preloader';
import { Preloading } from '../../UI/Preloader/action';
import { toast, ToastContainer } from 'react-toastify';
import { theodoreGetEmailOtp, theodoreResetPassword } from './action';
import Modal from "../../../components/UI/Modal/Modal";

class TheodoreForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            getOtpFormErrors: { username: '' },
            resetFormErrors: { otp: "", newPassword: "" },
            showModal: false,
            resizeZIndex: false
        }
    }
    componentWillUnmount() {
        this.props.preloading(false);
    }

    handleToggleModal = () => {
        this.setState({ ...this.initialState, showModal: !this.state.showModal, resetFormErrors: { otp: "", newPassword: "" } })
        document.getElementById('otp').value = "";
        document.getElementById('newPassword').value = "";
    }

    componentDidUpdate(prevProps) {
        if (this.props.theodoreGetOtpSuccess !== prevProps.theodoreGetOtpSuccess) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{this.props.theodoreGetOtpSuccess.message}
                </div>
            );
            this.props.preloading(false);
            this.setState({ showModal: !this.state.showModal })
        } else if (this.props.theodoreGetOtpFailure !== prevProps.theodoreGetOtpFailure) {
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;{(this.props.theodoreGetOtpFailure.response && this.props.theodoreGetOtpFailure.response.data) ? this.props.theodoreGetOtpFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            this.props.preloading(false);
        }

        if (this.props.theodoreResetPasswordSuccess !== prevProps.theodoreResetPasswordSuccess) {
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{this.props.theodoreResetPasswordSuccess.message}
                </div>
            );
            this.props.preloading(false);
            this.setState({ resizeZIndex: false })
            {
                setTimeout(function () {
                    // Redirect to login screen
                    window.location = '/';
                }, 2000);
            }
        } else if (this.props.theodoreResetPasswordFailure !== prevProps.theodoreResetPasswordFailure) {
            toast.error(
                <div>
                    <i className="fa fa-warning"></i>&nbsp;{(this.props.theodoreResetPasswordFailure.response && this.props.theodoreResetPasswordFailure.response.data) ? this.props.theodoreResetPasswordFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            this.props.preloading(false);
            this.setState({ resizeZIndex: false })
        }
    }

    isFormValid = (email) => {
        const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let errMsg = '';
        let isValidEmail = emailRex.test(email);
        if (!isValidEmail) {
            errMsg = 'Enter a valid username';
        }

        this.setState({
            getOtpFormErrors: { username: errMsg },
        });
        if (errMsg) {
            return false;
        }
        else return true;
    }

    forgotPasswordHandler = () => {
        let givenEmail = document.getElementById('username').value;
        if (this.isFormValid(givenEmail)) {
            this.props.preloading(true);
            // Make the n/w call to forgot password api
            let payload = { handle: document.getElementById('username').value, handleType: "email" }
            this.props.theodoreGetEmailOtp(payload);
        }
    }

    resetPasswordHandler = () => {
        let otp = document.getElementById('otp').value;
        let newPassword = document.getElementById('newPassword').value;
        let otpValidationError = this.isValidOtpTextFormat(otp);
        let newPasswordValidationError = this.isValidPasswordTextFormat(newPassword);
        this.setState({
            resetFormErrors : { otp : otpValidationError, newPassword: newPasswordValidationError}
        })
        if (otpValidationError === "" && newPasswordValidationError === "") {
            this.props.preloading(true);
            this.setState({ resizeZIndex: true })
            let payloadEmail = document.getElementById('username').value;
            let payloadBody = { otpString: document.getElementById('otp').value, newPassword: document.getElementById('newPassword').value }
            let payload = { email: payloadEmail, requestBody: payloadBody }
            this.props.theodoreResetPassword(payload);
        }
    }

    isValidOtpTextFormat = (otp) => {
        let otpRegex = /^\d{6}$/;
        if (!otpRegex.test(otp)) {
            return "OTP should be in number upto 6 digit.";
        }else{
            return "";
        }
    }

    isValidPasswordTextFormat = (passwordText) => {
        let passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){12,}$/gm;
        if (!passwordRegex.test(passwordText)) {
            return "Password should be alphanumeric with special character and length should be greater than 11.";
        }else{
            return "";
        }
    }

    render() {
        return (
            <section className="d-flex align-items-center justify-content-center h-100vh">
                <section className="pre-login">
                    <Form>
                        <Logo propClassName="mb-5" />
                        <FormGroup className="mb-4">
                            <Input type="email" name="username" id="username" placeholder="Email id" required invalid={this.state.getOtpFormErrors.username !== ''} />
                            <FormFeedback className="text-left" invalid>{this.state.getOtpFormErrors.username}</FormFeedback>
                        </FormGroup>
                        <Button size="lg" className="mb-4" name="btn-forgotPassword" color="primary" block onClick={this.forgotPasswordHandler}>Get OTP</Button>
                        <Link color="primary" block to="/" >&lt; Back to login</Link>
                    </Form>
                    <Modal show={this.state.showModal} className={this.state.resizeZIndex ? 'z-index-zero password-reset-modal Large-Modal' : 'password-reset-modal Large-Modal'}>
                        <ModalHeader>Reset Password</ModalHeader>
                        <ModalBody>
                            <FormGroup className="mb-4">
                                <Row className="mb-4">
                                    <Col>
                                        <Input type="text" name="otp" id="otp" placeholder="OTP" required invalid={this.state.resetFormErrors.otp !== ""} />
                                        <FormFeedback className="text-left" invalid>{this.state.resetFormErrors.otp}</FormFeedback>
                                    </Col>
                                </Row>
                                <Row className="mb-4"><Col>
                                    <Input type="password" name="newPassword" id="newPassword" placeholder="New Password" required invalid={this.state.resetFormErrors.newPassword !== ""} />
                                    <FormFeedback className="text-left" invalid>{this.state.resetFormErrors.newPassword}</FormFeedback>
                                </Col> </Row>
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter>
                            <Button size="lg" className="mb-2" name="btn-resetPassword" color="primary" onClick={this.resetPasswordHandler}>Reset</Button>
                            <Button color="primary" type="button" onClick={this.handleToggleModal}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </section>

                <Preloader></Preloader>
                <ToastContainer hideProgressBar={true} position="top-center" autoClose={3000}></ToastContainer>
            </section>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    theodoreGetOtpSuccess: state.forgotTheodorePassword.theodoreGetOtpSuccess,
    theodoreGetOtpFailure: state.forgotTheodorePassword.theodoreGetOtpFailure,
    theodoreResetPasswordSuccess: state.forgotTheodorePassword.theodoreResetPasswordSuccess,
    theodoreResetPasswordFailure: state.forgotTheodorePassword.theodoreResetPasswordFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    theodoreGetEmailOtp: (email) => { dispatch(theodoreGetEmailOtp(email)) },
    theodoreResetPassword: (data) => { dispatch(theodoreResetPassword(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TheodoreForgotPassword);